export default {
  primary: {
    color: 'light',
    border: 'solid 1px',
    fontSize: '0.7rem',
    fontWeight: '700',
    textTransform: 'uppercase',
    paddingBottom: '0rem',
    padding: '1rem 3rem',
    borderColor: 'light',
    backgroundColor: 'transparent',
    ':hover': {
      backgroundColor: 'dark',
      color: 'light'
    }
  },
  secondary: {
    backgroundColor: 'black',
    padding: '1rem',
    color: 'text',
    border: 'none',
    border: 'solid 2px',
    borderColor: 'secondary',
    borderRadius: '0px',
    fontWeight: 'bold',
    WebkitTextStroke: '0.5px #896d36',
    display: 'flex',
    fontSize: '1rem',
    transition: 'all ease-in-out 0.8s',
    ':hover': {
      // opacity: '0.4',
      backgroundColor: 'secondary',
      color: 'light'
    }
  }
}
